<template>
  <!-- 合同管理 -->
  <div>
    <el-row>
      <!-- 工具条 -->
      <el-form :inline="true" :model="formInline" class="demo-form-inline toolbar" style="padding-bottom: 0px"
        @submit.native.prevent>
        <el-form-item label="老人姓名">
          <el-autocomplete v-model.trim="formInline.oldName" auto-complete="off" :clearable="true" placeholder="请选择老人" style="width: 100%"
            :fetch-suggestions="queryOlder" @select="SelectOld"></el-autocomplete>
        </el-form-item>
        <el-form-item label="合同时间">
          <el-date-picker :clearable="true" v-model="formInline.year" type="year" placeholder="请选择查询年份"
            value-format="yyyy" format="yyyy"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="search" plain>查询</el-button>
          <el-button type="warning" icon="el-icon-plus" @click="addContract" plain>添加</el-button>
          <el-button
              type="info"
              @click="exportContract"
              icon="el-icon-download"
              plain>合同导出</el-button>
        </el-form-item>
      </el-form>
      <el-table style="width: 100%" :data="tableData" v-loading="tableLoading" :header-cell-style="{
        'text-align': 'center',
        'font-size': '16px',
        'font-weight': '600',
        color: '#2d2d2d',
        'background-color': '#d4f5fa',
      }" :cell-style="{ 'text-align': 'center', 'font-size': '16px' }" :row-style="tableRowStyle">
        <el-table-column prop="contractNo" label="合同编号" min-width="90" show-overflow-tooltip></el-table-column>
        <el-table-column prop="contractType" label="合同类型" min-width="120"></el-table-column>
        <el-table-column prop="oldName" label="老人姓名" min-width="100"></el-table-column>
        <el-table-column prop="oldPhone" label="联系电话" min-width="120"></el-table-column>
        <el-table-column prop="warrantor" label="担保人" min-width="100"></el-table-column>
        <el-table-column prop="wrntPhoneOne" label="担保人联系电话" min-width="120"></el-table-column>
        <el-table-column prop="signDay" label="签约时间" min-width="100"></el-table-column>
        <el-table-column prop="contractEnd" label="结束时间" min-width="100"></el-table-column>
        <el-table-column prop="creator" label="签约人" min-width="100"></el-table-column>
        <el-table-column label="操作" min-width="120">
          <template slot-scope="scope">
            <a @click="handleEdit(scope.$index, scope.row)" class="curcor">
              <img class="handedness" src="@/assets/beadhouse/xiugai_icon_1.png" />
            </a>
            <a @click="handleDelete(scope.$index, scope.row)" class="curcor" style="margin-left:20px">
              <img class="handedness" src="@/assets/beadhouse/shanchu_icon.png" />
            </a>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background @current-change="handleCurrentChange" :current-page="currentPage"
        layout="total, prev, pager, next" :total="totalDataNumber" :page-size="pageSize" align="center" class="fenye">
      </el-pagination>
    </el-row>
  </div>
</template>
<script>
import bus from "@/vuex/eventBus"; //引入eventBus,接收子界面传递的跳转指令,然后在父界面跳转,添加tab
import { baseURL } from "@/utils/request.js";
export default {
  name: "ContractManage",
  data() {
    return {
      formInline: {
        oldName: "",
        oldmanId: null,
        year: "",
      },
      tableData: [], //表格数据
      tableLoading: false, //表格加载的loading
      /* 分页的 */
      currentPage: 1, //初始页
      pageNo: 1, //页码
      pageSize: 10, //每页显示的条数
      totalDataNumber: 0, //数据的总数,
      fieldsVisisble: false,
      oldNameOptions: [], // 老人姓名集合
    };
  },
  methods: {
    //修改table tr行的背景色
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "background-color: #ffffff";
      } else {
        return "background-color: #e4f5f8";
      }
    },
    /*
      添加老人
    */
    addContract() {
      bus.$emit("homePage", {
        type: "jump",
        path: "/ContractAdd",
        title: "新增合同",
      });
    },
    //导出
    exportContract() {
      let oldmanId = ``;
      let year = ``;
      if (this.formInline.oldmanId) {
        oldmanId = `&oldmanId=${this.formInline.oldmanId}`;
      }
      if (this.formInline.year) {
        year = `&year=${this.formInline.year}`;
      }
      window.location.href =
        baseURL +
        `omc/api/downOldManContract?groupId=${window.sessionStorage.getItem("groupId")}${oldmanId}${year}`;
    
    },
    handleDelete(index, row) {

    },
    /*
      修改老人信息
    */
    handleEdit(index, row) {
      bus.$emit("homePage", {
        type: "jump",
        path: "/ContractAdd",
        title: "编辑合同",
        params: {
          contractId: row.id
        }
      });
    },
    /*
      点击查询
    */
    search() {
      this.queryContract(
        this.formInline.oldmanId,
        this.formInline.year,
        (this.pageNo = 1),
        (this.pageSize = 10)
      );
    },
    /* 
    模糊查询老人
    */
    queryOlder(queryString, cb) {
      let param = {
        oldName: queryString
      };
      this.$postJson("omc/Oldman/quickShowAllOldMan", param).then((res) => {
        var list = [];
        if (res.result.list.length > 0) {
          for (let i of res.result.list) {
            i.value = i.oldName; //将想要展示的数据作为value
          }
          list = res.result.list;
          cb(list);
        } else {
          let arr = [];
          arr.push({
            uuid: "-1",
            value: "",
          });
          cb(arr);
          setTimeout(() => {
            this.formInline.oldName = "";
          }, 1000);
        }
      });
    },
    SelectOld(item) {
      this.formInline.oldmanId = item.oldmanId;
      this.formInline.oldName = item.oldName;
    },
    /*
      键盘事件 按下键盘回车 查询
    */
    enterSearchMember(e) {
      // console.log("回车搜索", keyCode, e);
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13 && this.formInline.oldName != null) {
        this.search();
      }
    },
    /*
      查询老人分页列表
    */
    queryContract() {
      let params = {};
      if (this.formInline.oldmanId != "" || null || undefined) {
        params.oldmanId = this.formInline.oldmanId;
      }
      if(this.formInline.oldName == "" || null || undefined){
        params.oldmanId = null;
      }
      if (this.formInline.year != "" || null || undefined) {
        params.year = this.formInline.year;
      }
      params.pageNo = String(this.pageNo);
      params.pageSize = String(this.pageSize);
      this.tableData = [];
      this.tableLoading = true;
      this.$postJson("omc/oldContract/queryWithPage", params).then((res) => {
        if (res.code == 200) {
          if (res.result.list != null) {
            this.pageSize = res.result.pageSize;
            this.currentPage = res.result.pageNum;
            this.totalDataNumber = res.result.total * 1;
            this.tableData = res.result.list;
          } else {
            this.tableData = [];
            this.pageSize = 10;
            this.currentPage = 1;
            this.totalDataNumber = 0;
          }
        } else {
          this.tableData = [];
          this.pageSize = 10;
          this.currentPage = 1;
          this.totalDataNumber = 0;
        }
        setTimeout(() => {
          this.tableLoading = false;
        }, 500);
      });
    },
    /*
      当前页变化
    */
    handleCurrentChange(val) {
      this.pageNo = val;
      this.queryContract(); //刷新套餐列表的数据
    },
  },
  mounted() {
    this.queryContract();
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.fenye {
  padding: 30px 0;
  background: #fff;
}
</style>
  